// extracted by mini-css-extract-plugin
export var item = "contactInfos-module--item--55f6d";
export var socials = "contactInfos-module--socials--fa5c8";
export var wrapper = "contactInfos-module--wrapper--1e8d8";